import React from 'react';


const WelcomeMessage = () => {
  return (
    <div className="text-center mb-8 px-4">
      <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
        Welcome to Your Personal Sales Coach
      </h1>
      <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        I'm Lumo, your AI-powered sales coach. I'm here to help you master sales conversations through daily practice, personalized feedback, and proven techniques.
      </p>
    </div>
  );
};

export default WelcomeMessage;